import React from 'react';
import { MapContainer, Marker, Popup, TileLayer } from 'react-leaflet';

const LiveLocation = () => {
    return (
        <div className='p-3'>
            <div className='p-3 bg-gray-100 rounded-lg shadow-lg border'>
                <MapContainer center={[51.505, -0.09]} zoom={20} scrollWheelZoom={false} className="w-full h-[70vh]">
                    <TileLayer
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    <Marker position={[51.505, -0.09]}>
                        <Popup>
                        A pretty CSS3 popup. <br /> Easily customizable.
                        </Popup>
                    </Marker>
                </MapContainer>
            </div>
        </div>
    );
};

export default LiveLocation;